export enum AppModalTypeEnum {
    Snackbar = 'snackbar',
    Dialog = 'dialog',
    Modal = 'modal',
}
